<template>
  <a-form :form="form" @submit="handleSubmit">
    <a-form-item label="Fund">
      <a-select
        show-search
        option-filter-prop="children"
        @change="onFundChange"
        v-decorator="[
          'fundId',
          { rules: [{ required: true, message: 'Please select a fund' }] },
        ]"
      >
        <a-select-option v-for="fund in funds" :key="fund.id" :value="fund.id">
          {{ fund.name }}
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item label="Class">
      <a-select
        v-decorator="[
          'classKey',
          { rules: [{ required: true, message: 'Please select a class' }] },
        ]"
      >
        <a-select-option
          v-for="classItem in classes"
          :key="classItem.key"
          :value="classItem.key"
        >
          {{ classItem.name }}
        </a-select-option>
      </a-select>
    </a-form-item>
    <a-form-item>
      <a-button type="primary" html-type="submit" :disabled="submitting">
        Add
      </a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import gql from 'graphql-tag'

export default {
  props: {
    index: {
      type: String,
      required: true,
    },
  },
  apollo: {
    funds: {
      client: 'funds',
      query: gql`
        query {
          funds {
            id
            key
            name
          }
        }
      `,
    },
  },
  data() {
    return {
      classes: [],
      funds: [],
      form: this.$form.createForm(this),
      submitting: false,
    }
  },
  methods: {
    async onFundChange(value) {
      const response = await this.$apollo.query({
        client: 'funds',
        query: gql`
          query GetFundClasses($fundId: Int!) {
            fundClasses(fundId: $fundId) {
              key
              name
            }
          }
        `,
        variables: { fundId: value },
      })
      this.classes = response.data.fundClasses
      this.classValue = null
    },
    clearForm() {
      this.form.getForm().resetFields()
    },
    async addConstituent({ classKey, className, fundKey, fundName }) {
      const response = await this.$apollo.mutate({
        mutation: gql`
          mutation($input: AddClassConstituentInput) {
            addClassConstituent(input: $input) {
              class {
                key
                name
                fund {
                  name
                }
              }
            }
          }
        `,
        variables: {
          input: {
            classKey: classKey,
            className: className,
            fundKey: fundKey,
            fundName: fundName,
            index: this.index,
          },
        },
      })
      return response.data.addClassConstituent.class
    },
    async handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields(async (err, values) => {
        {
          if (!err) {
            this.submitting = true
            const selectedFund = this.funds.find((f) => f.id === values.fundId)
            const selectedClass = this.classes.find(
              (c) => c.key === values.classKey,
            )
            try {
              const constituent = await this.addConstituent({
                classKey: selectedClass.key,
                className: selectedClass.name,
                fundKey: selectedFund.key,
                fundName: selectedFund.name,
              })
              this.clearForm()
              this.$emit('constituentAdded', constituent)
              this.submitting = false
            } catch (error) {
              console.log(error)
              this.$message.error('Adding constituent failed!')
              this.submitting = false
            }
          }
        }
      })
    },
  },
}
</script>

<style></style>
